// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-container {
  height: 100vh;
  background-size: cover;
  height: 100vh;
  font-family: 'Inter';
  color: black;
  gap: 4rem;
  display: flex;
  flex-direction: column;
}

.add-item-form {
  background-color: #e5e7ebe2;
  margin-bottom: 2rem;
  padding: 1.6rem 3.2rem;
  margin-right: 2rem;
  margin-left: 2rem;
  display: flex;
  align-items: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;
  border-radius: 1.6rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.add-item-item-name,
.add-item-item-size,
.add-item-item-price,
.add-item-item-quantity,
.add-item-item-notes {
  background-color: #ffffff;
  border: none;
  border-radius: 100rem;
  padding: 1rem;
  margin-left: 1rem;
  font-size: 1.4rem;
  width: 20rem;
}

.post-btn {
  border-radius: 100rem;
  padding: 1rem 4rem;
  border: none;
  background-color: #37513e;
  color: white;
  font-weight: bold;
  font-size: 1.4rem;
}

.post-btn:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

.products {
  border: 0.2rem solid #274e13;
  font-family: Inter;
  color: #274e13;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.products:hover {
  color: white;
  cursor: pointer;
  background-color: #274e13;
}

.orders {
  border: 0.2rem solid #ce7e00;
  font-family: Inter;
  color: #ce7e00;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.orders:hover {
  color: white;
  cursor: pointer;
  background-color: #ce7e00;
}

.settings {
  border: 0.2rem solid;
  font-family: Inter;
  color: #343a40;
  font-weight: 500;
  font-weight: bold;
  font-size: 1.4rem;
}

.settings:hover {
  color: white;
  cursor: pointer;
  background-color: #343a40;
}

.edit-changes {
  background-color: #ce7e00;
}

.vendor-container {
  overflow: scroll;
}

@media (max-width: 1077px) {
  .add-item-item-name,
  .add-item-item-size,
  .add-item-item-price,
  .add-item-item-quantity,
  .add-item-item-notes {
    font-size: 1.2rem;
  }
  .add-item-form {
    gap: 1rem;
  }
  .post-btn {
    font-size: 1.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VendorDashboard/VendorDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;;;;EAKE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;;IAKE,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".vendor-container {\n  height: 100vh;\n  background-size: cover;\n  height: 100vh;\n  font-family: 'Inter';\n  color: black;\n  gap: 4rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.add-item-form {\n  background-color: #e5e7ebe2;\n  margin-bottom: 2rem;\n  padding: 1.6rem 3.2rem;\n  margin-right: 2rem;\n  margin-left: 2rem;\n  display: flex;\n  align-items: space-between;\n  flex-wrap: wrap;\n  gap: 1.6rem;\n  border-radius: 1.6rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.add-item-item-name,\n.add-item-item-size,\n.add-item-item-price,\n.add-item-item-quantity,\n.add-item-item-notes {\n  background-color: #ffffff;\n  border: none;\n  border-radius: 100rem;\n  padding: 1rem;\n  margin-left: 1rem;\n  font-size: 1.4rem;\n  width: 20rem;\n}\n\n.post-btn {\n  border-radius: 100rem;\n  padding: 1rem 4rem;\n  border: none;\n  background-color: #37513e;\n  color: white;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.post-btn:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n.products {\n  border: 0.2rem solid #274e13;\n  font-family: Inter;\n  color: #274e13;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.products:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #274e13;\n}\n\n.orders {\n  border: 0.2rem solid #ce7e00;\n  font-family: Inter;\n  color: #ce7e00;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.orders:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #ce7e00;\n}\n\n.settings {\n  border: 0.2rem solid;\n  font-family: Inter;\n  color: #343a40;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n\n.settings:hover {\n  color: white;\n  cursor: pointer;\n  background-color: #343a40;\n}\n\n.edit-changes {\n  background-color: #ce7e00;\n}\n\n.vendor-container {\n  overflow: scroll;\n}\n\n@media (max-width: 1077px) {\n  .add-item-item-name,\n  .add-item-item-size,\n  .add-item-item-price,\n  .add-item-item-quantity,\n  .add-item-item-notes {\n    font-size: 1.2rem;\n  }\n  .add-item-form {\n    gap: 1rem;\n  }\n  .post-btn {\n    font-size: 1.2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
